import styled from '@emotion/styled';
import { mediaQuery, Spacings, Fonts } from '@styles/index';
import Image from '@base/FutureImage';
import Dialog from '@comp/Dialog/Dialog';
import AquillaButton from 'aquilla/core/molecules/Button';

const MainText = styled.div`
  color: var(--color-i-black);
  font-size: ${Fonts.H3};
  font-weight: ${Fonts.HEAVY};
  line-height: ${Spacings.SPACING_7B};
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.H4};
  }
`;

const SubText = styled.div`
  color: var(--color-i-gray-13);
  font-size: ${Fonts.P1};
  font-weight: ${Fonts.REGULAR};
  line-height: ${Spacings.SPACING_4B};
  margin-top: 12px;
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.P2};
  }
`;

const LoginCTAWrapper = styled.div`
  display: flex;
  gap: ${Spacings.SPACING_4B};
  margin-top: 15px;

  ${mediaQuery.uptoMobile} {
    width: 100%;
    justify-content: end;
    gap: ${Spacings.SPACING_2B};
  }
`;

const NewLoginCTA = styled(AquillaButton)`
  padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_5B};
  flex: 1;
  height: 50px;
  border-radius: ${Spacings.SPACING_6};
  font-weight: 600;
  font-size: ${Fonts.H5};
  line-height: ${Spacings.SPACING_4B};
  white-space: nowrap;

  ${mediaQuery.uptoMobile} {
    padding: ${Spacings.SPACING_2B} ${Spacings.SPACING_14};
    height: 40px;
    width: unset;
    min-width: 64px;
  }
`;

const StyledImg = styled(Image)`
  width: 100%;
  height: 100%;
  border-radius: ${Spacings.SPACING_3B};
`;

const Modal = styled(Dialog)`
  &.MuiDialog-root {
    .MuiDialog-container {
      display: flex;
      justify-content: center;
      align-items: center;

      .MuiPaper-root {
        height: 300px;
        width: 600px;
        position: relative;
        padding: 24px;
        border-radius: 8px;
        ${mediaQuery.uptoMobile} {
          position: absolute;
          height: auto;
        }

        .MuiDialogContent-root {
          padding-top: 24px;
        }
      }
    }
  }
`;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;

const TopSection = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const TextSection = styled.div`
  padding: 12px;
  width: 70%;
`;

const ImageSection = styled.div`
  padding: 12px;
  width: 30%;
`;

const AllowLocationModal = ({ showlocationModal, closeLocaltionModal }) => {
  const handleGotIt = () => {
    closeLocaltionModal();
  };

  return (
    <Modal dialogState={showlocationModal} onClose={closeLocaltionModal}>
      <Container>
        <TopSection>
          <TextSection>
            <MainText>
              Allow location permission to find the nearest centre
            </MainText>
            <SubText>
              You can enable location permission from the settings page of your
              browser.
            </SubText>
          </TextSection>
          <ImageSection>
            <StyledImg
              src="allCentre/allowLocation.svg"
              height={70}
              width={70}
              alt="Location Icon"
            />
          </ImageSection>
        </TopSection>
        <LoginCTAWrapper>
          <NewLoginCTA onClick={handleGotIt}>Got it</NewLoginCTA>
        </LoginCTAWrapper>
      </Container>
    </Modal>
  );
};

export default AllowLocationModal;
